export default "__VITE_ASSET__BTeCCwfC__"